export const classNames = {
  base: 'dw-tooltip',
  noPadding: 'dw-tooltip--p0',
};
